import Login from "./pages/Login";
import Signup from "./pages/SignUp";
import Profile from "./pages/Profile";
import Settings from "./pages/Settings";
import EditProfile from "./pages/settings/EditProfile";
import Notifications from "./pages/settings/Notifications";
import AccountPrivacy from "./pages/settings/AccountPrivacy";
import ExplorePage from "./pages/ExplorePages.jsx";
import MessagesPage from "./pages/MessagesPage.jsx";
import PostsPage from "./pages/PostsPage.jsx";
import FeedPage from "./pages/Feedpage.jsx";
import PostPage from "./pages/PostPage.jsx";

import ProtectedRoute from "./components/ProtectedRoute";
import PublicRoute from "./components/PublicRoute";

import { BrowserRouter, Routes, Route } from "react-router-dom";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* PUBLIC ROUTES */}
        <Route
          path="/"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />

        <Route
          path="/signup"
          element={
            <PublicRoute>
              <Signup />
            </PublicRoute>
          }
        />

        {/* PROTECTED ROUTES */}
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route path="/user/:username" element={<Profile />} /> 

        <Route path="/explore" element={<ExplorePage />} />

        <Route path="/posts" element={<PostsPage />} />
        <Route path="/posts/:postId" element={<PostsPage />} />

        <Route path="/feed" element={<FeedPage />} />
        <Route path="/p/:postId" element={<PostPage />} />
        <Route path="/profile/saved" element={<Profile />} />
        <Route path="/profile" element={<Profile />} />

        <Route
          path="/messages"
          element={
            <ProtectedRoute>
              <MessagesPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          }
        >
          <Route index element={<EditProfile />} />
          <Route path="/settings/notifications" element={<Notifications />} />
          <Route path="/settings/privacy" element={<AccountPrivacy />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
